import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PERMISSION } from "core/http/service/accountInfo/resTypes";
import { ReduxStateType } from "redux-store/types";

interface IDataPermissionItem {
  [screenCode: string]: { [itemCode: string]: PERMISSION[] };
}

interface InitialState {
  data: IDataPermissionItem;
  status: ReduxStateType;
}

const initialState: InitialState = {
  data: {},
  status: ReduxStateType.INIT,
};

const getPermissionItemSlice = createSlice({
  name: "getPermissionItem",
  initialState,
  reducers: {
    getPermissionItemStart: (state, action: PayloadAction<string>) => {
      state.status = ReduxStateType.LOADING;
    },
    getPermissionItemSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      Object.assign(state.data, action.payload);
    },
    getPermissionItemFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetPermissionItem: () => initialState,
  },
});

export const {
  getPermissionItemStart,
  getPermissionItemSuccess,
  getPermissionItemFailed,
  resetPermissionItem,
} = getPermissionItemSlice.actions;

export default getPermissionItemSlice.reducer;
